import { Button } from "@material-ui/core"
import { Benefit } from "api"
import { trackPopUpOpen } from "common/analytics"
import { useState } from "react"
import styled from "styled-components"
import colors from "theme/colors"
import { StyledCol, TypographyCenter, TypographyRtl } from "theme/shared"
import BenefitPopup from "../popups/BenefitPopup"

const StyledWrapper = styled.div``

const StyledCard = styled.div`
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin: 0 auto;
  }
  background-color: ${colors.white};
  border-radius: 6px;
  padding: 30px 20px 20px;
  max-width: 277px;
  border: 0.5px solid ${(p) => p.theme.colors.borderGrey};
  border-radius: 6px;
`
const StyledCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  ${(p) => p.theme.breakpoints.up("md")} {
    flex-direction: row;
    flex-wrap: wrap;
  }
`
type CenterBenefitsProps = {
  centerBenefits?: Benefit[]
}

const CenterBenefits = ({ centerBenefits }: CenterBenefitsProps) => {
  const [activeBenefit, setActiveBenefit] = useState<Benefit | null>(null)

  if (!centerBenefits.length) return null

  return (
    <StyledWrapper>
      {!!centerBenefits?.length && (
        <>
          <TypographyRtl
            $mb="20px"
            variant="h2"
            $fontSize="20px"
            $fontWeight="300"
          >
            ההטבות שלנו
          </TypographyRtl>
          <StyledCardWrapper>
            {centerBenefits.map((benefit) => (
              <StyledCard key={benefit.id}>
                <StyledCol
                  $gap="20px"
                  $fullWidth={true}
                  $justify="space-between"
                  $height="100%"
                >
                  <StyledCol $gap="10px" $fullWidth>
                    <TypographyCenter
                      variant="h3"
                      $fontSize="24px"
                      $fontWeight="400"
                    >
                      {benefit?.name}
                    </TypographyCenter>
                    <TypographyCenter variant="body1">
                      {benefit?.description}
                    </TypographyCenter>
                  </StyledCol>
                  <StyledCol $gap="20px" $fullWidth>
                    <Button
                      onClick={() => {
                        setActiveBenefit(benefit)
                        trackPopUpOpen(benefit?.name)
                      }}
                      disableRipple={false}
                      disableFocusRipple={false}
                    >
                      אני רוצה את ההטבה
                    </Button>
                    <TypographyCenter variant="caption">
                      {benefit?.legalizationComment}
                    </TypographyCenter>
                  </StyledCol>
                </StyledCol>
              </StyledCard>
            ))}
          </StyledCardWrapper>
        </>
      )}
      <BenefitPopup
        onClose={() => setActiveBenefit(null)}
        benefit={activeBenefit}
      />
    </StyledWrapper>
  )
}

export default CenterBenefits
